export default {
    'Sign In Account': ' ', // Change translation of aws amplify login header
};
